import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon, PenToolIcon, UsersIcon, BarChartIcon, FeatherIcon, ExternalLinkIcon, FileTextIcon, LayoutIcon, BookOpenIcon } from 'lucide-react';
import { TestimonialCard } from '../components/TestimonialCard';
import { BlogPreviewCard } from '../components/BlogPreviewCard';
export function Home() {
  const testimonials = [{
    quote: 'Muthamia Content transformed our brand voice. Their storytelling approach helped us connect with our audience in ways we never imagined possible.',
    author: 'Jane Mwangi',
    position: 'Marketing Director',
    company: 'Savannah Innovations'
  }, {
    quote: 'The team at Muthamia Content understands the Kenyan market deeply. Their content strategy doubled our engagement and helped position us as industry leaders.',
    author: 'David Ochieng',
    position: 'CEO',
    company: 'Frontier Solutions'
  }, {
    quote: 'Working with Muthamia Content has been transformative for our public communications. They bring clarity, creativity and strategic thinking to every project.',
    author: 'Sarah Kimani',
    position: 'Communications Lead',
    company: 'East African Initiative'
  }];
  const [featuredBlogPosts, setFeaturedBlogPosts] = useState([{
    id: '1',
    title: 'The Art of Brand Storytelling in East Africa',
    date: 'June 12, 2023',
    category: 'Brand Strategy'
  }, {
    id: '2',
    title: 'Digital Content Strategies for the Kenyan Market',
    date: 'May 24, 2023',
    category: 'Digital Content'
  }, {
    id: '3',
    title: 'The Rise of Native Advertising in African Media',
    date: 'April 18, 2023',
    category: 'Content Marketing'
  }]);
  useEffect(() => {
    // Fetch featured blog posts
    fetch('http://localhost:3001/posts?_limit=3').then(response => response.json()).then(data => {
      if (data && data.length > 0) {
        setFeaturedBlogPosts(data.map(post => ({
          id: post.id,
          title: post.title,
          date: post.date,
          category: post.category
        })));
      }
    }).catch(error => console.error('Error fetching featured posts:', error));
  }, []);
  return <div className="w-full" data-id="element-1235">
      {/* Hero Section */}
      <section className="cream-bg py-20 md:py-32 w-full" data-id="element-1236">
        <div className="container mx-auto px-4" data-id="element-1237">
          <div className="max-w-3xl mx-auto text-center" data-id="element-1238">
            <div className="flex justify-center mb-6" data-id="element-1239">
              <FeatherIcon size={40} className="accent-color fade-in-up" data-id="element-1240" />
            </div>
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-6 leading-tight elegant-heading fade-in-up delay-100" data-id="element-1241">
              Brand Strategy Meets Storytelling
            </h1>
            <p className="text-xl md:text-2xl navy-text mb-8 fade-in-up delay-200" data-id="element-1242">
              Empowering brands to communicate boldly, natively, and
              intelligently.
            </p>
            <div className="flex flex-col sm:flex-row justify-center gap-4 fade-in-up delay-300" data-id="element-1243">
              <Link to="/services" className="inline-flex items-center justify-center navy-bg text-white hover:bg-opacity-90 px-8 py-4 rounded-md text-lg font-medium transition-colors" data-id="element-1244">
                <span data-id="element-1245">Explore Our Services</span>
                <ArrowRightIcon size={20} className="ml-2" data-id="element-1246" />
              </Link>
              <Link to="/contact" className="inline-flex items-center justify-center gold-gradient text-white hover:bg-opacity-90 px-8 py-4 rounded-md text-lg font-medium transition-colors" data-id="element-1247">
                <span data-id="element-1248">Get in Touch</span>
              </Link>
            </div>
          </div>
        </div>
      </section>
      {/* Introduction Section */}
      <section className="py-16 md:py-24 w-full bg-white" data-id="element-1249">
        <div className="container mx-auto px-4" data-id="element-1250">
          <div className="max-w-3xl mx-auto text-center" data-id="element-1251">
            <h2 className="text-3xl md:text-4xl font-bold mb-6 elegant-heading" data-id="element-1252">
              Welcome to Muthamia Content
            </h2>
            <div className="elegant-divider" data-id="element-1253"></div>
            <p className="text-lg accent-color mb-6 elegant-subheading" data-id="element-1254">
              Where ideas evolve into narrative powerhouses.
            </p>
            <p className="navy-text mb-8" data-id="element-1255">
              We help corporations, institutions, media platforms and visionary
              brands tell their stories through high-impact content, strategy,
              and native intelligence. From editorial finesse to video-driven
              advertising, we merge creative storytelling with bold brand
              strategy - and always in a voice that resonates.
            </p>
          </div>
        </div>
      </section>
      {/* Core Services Section */}
      <section className="py-16 cream-bg w-full" data-id="element-1256">
        <div className="container mx-auto px-4" data-id="element-1257">
          <div className="max-w-3xl mx-auto text-center mb-16" data-id="element-1258">
            <h2 className="text-3xl font-bold mb-4 elegant-heading" data-id="element-1259">
              What We Do
            </h2>
            <p className="navy-text" data-id="element-1260">
              We combine strategic thinking with creative execution to deliver
              content that connects.
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-10 max-w-5xl mx-auto" data-id="element-1261">
            <div className="text-center elegant-card p-8 bg-white" data-id="element-1262">
              <div className="flex justify-center mb-6" data-id="element-1263">
                <div className="w-16 h-16 rounded-full gold-gradient flex items-center justify-center" data-id="element-1264">
                  <PenToolIcon size={32} className="text-white" data-id="element-1265" />
                </div>
              </div>
              <h3 className="text-xl font-bold mb-4" data-id="element-1266">Brand Storytelling</h3>
              <p className="text-gray-700" data-id="element-1267">
                We craft campaign narratives that move people, from product
                launches to brand manifestos.
              </p>
            </div>
            <div className="text-center elegant-card p-8 bg-white" data-id="element-1268">
              <div className="flex justify-center mb-6" data-id="element-1269">
                <div className="w-16 h-16 rounded-full burgundy-bg flex items-center justify-center" data-id="element-1270">
                  <FileTextIcon size={32} className="text-white" data-id="element-1271" />
                </div>
              </div>
              <h3 className="text-xl font-bold mb-4" data-id="element-1272">Content Creation</h3>
              <p className="text-gray-700" data-id="element-1273">
                From SEO-optimized website content to thought leadership
                articles that position you as an industry leader.
              </p>
            </div>
            <div className="text-center elegant-card p-8 bg-white" data-id="element-1274">
              <div className="flex justify-center mb-6" data-id="element-1275">
                <div className="w-16 h-16 rounded-full rich-purple-bg flex items-center justify-center" data-id="element-1276">
                  <LayoutIcon size={32} className="text-white" data-id="element-1277" />
                </div>
              </div>
              <h3 className="text-xl font-bold mb-4" data-id="element-1278">Strategy & Campaigns</h3>
              <p className="text-gray-700" data-id="element-1279">
                We develop advertising and brand campaigns that connect - not
                just impress.
              </p>
            </div>
          </div>
          <div className="text-center mt-12" data-id="element-1280">
            <Link to="/services" className="inline-flex items-center justify-center px-8 py-3 luxury-border rounded-md hover:border-gray-400 transition-colors elegant-button" data-id="element-1281">
              <span className="font-medium" data-id="element-1282">View all services</span>
              <ArrowRightIcon size={18} className="ml-2" data-id="element-1283" />
            </Link>
          </div>
        </div>
      </section>
      {/* Blog Posts Section */}
      <section className="py-16 w-full" data-id="element-1284">
        <div className="container mx-auto px-4" data-id="element-1285">
          <div className="max-w-3xl mx-auto text-center mb-12" data-id="element-1286">
            <div className="flex justify-center mb-4" data-id="element-1287">
              <BookOpenIcon size={32} className="accent-color" data-id="element-1288" />
            </div>
            <h2 className="text-3xl font-bold mb-4 elegant-heading" data-id="element-1289">
              From Our Blog
            </h2>
            <div className="elegant-divider" data-id="element-1290"></div>
            <p className="text-gray-700" data-id="element-1291">
              Insights, strategies, and stories from the world of content and
              brand storytelling.
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-1292">
            {featuredBlogPosts.map(post => <BlogPreviewCard key={post.id} id={post.id} title={post.title} category={post.category} date={post.date} data-id="element-1293" />)}
          </div>
          <div className="text-center mt-12" data-id="element-1294">
            <Link to="/blog" className="inline-flex items-center justify-center px-8 py-3 border border-gray-200 rounded-md hover:border-gray-300 transition-colors elegant-button" data-id="element-1295">
              <span className="font-medium" data-id="element-1296">View all blog posts</span>
              <ArrowRightIcon size={18} className="ml-2" data-id="element-1297" />
            </Link>
          </div>
        </div>
      </section>
      {/* Testimonials Section */}
      <section className="py-16 bg-gray-50 w-full" data-id="element-1298">
        <div className="container mx-auto px-4" data-id="element-1299">
          <h2 className="text-3xl font-bold mb-12 text-center elegant-heading" data-id="element-1300">
            What Our Clients Say
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-1301">
            {testimonials.map((testimonial, index) => <TestimonialCard key={index} quote={testimonial.quote} author={testimonial.author} position={testimonial.position} company={testimonial.company} data-id="element-1302" />)}
          </div>
        </div>
      </section>
    </div>;
}